import React from 'react';
import PropTypes from 'prop-types';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import EditProjectModal from '../../../EditProjectModal';
import Header from './Header';
import Details from './Details';
import { projectDataShape, adminAccessProductsPropTypes } from '../propTypes';
import { MAPBOX_TOKEN } from '../constants';
import { progressRingWrapperDivStyle, progressRingStyle } from '../styles';

const Content = ({
  adminAccessProducts,
  data,
  isAdminUser,
  loading,
  onEditButtonClick,
  onEditProjectClose,
  onEditProjectSubmit,
  showAdditionalFields,
  showEditProject,
  showInProductSettings,
}) => {
  if (loading) {
    return (
      // TODO: Implement generic/shared progress ring page block component
      <div css={progressRingWrapperDivStyle}>
        <ProgressRing
          style={progressRingStyle}
          size={ProgressRing.SIZES.MEDIUM}
        />
      </div>
    );
  }

  return (
    <>
      <Header
        adminAccessProducts={adminAccessProducts}
        onEditButtonClick={onEditButtonClick}
        showEditButton={isAdminUser}
        showInProductSettings={showInProductSettings}
      />
      <Details data={data} showAdditionalFields={showAdditionalFields} />
      {isAdminUser && (
        <EditProjectModal
          show={showEditProject}
          mapBoxAccessToken={MAPBOX_TOKEN}
          onClose={onEditProjectClose}
          onSubmit={onEditProjectSubmit}
        />
      )}
    </>
  );
};

Content.propTypes = {
  adminAccessProducts: adminAccessProductsPropTypes,
  data: projectDataShape,
  isAdminUser: PropTypes.bool,
  loading: PropTypes.bool,
  onEditButtonClick: PropTypes.func,
  onEditProjectClose: PropTypes.func,
  onEditProjectSubmit: PropTypes.func,
  showAdditionalFields: PropTypes.bool,
  showEditProject: PropTypes.bool,
  showInProductSettings: PropTypes.bool,
};

export default Content;
